import { SettingsPage } from 'Features/Projects/Scenarios/EditSettings/SettingsPage'
import { useSettingsContext } from 'Features/Projects/Scenarios/EditSettings/EditSettings.types'
import { ReplenishmentTable } from 'Features/Projects/Scenarios/EditSettings/NetworkSettings/Replenishment/Replenishment.Table'
import { useReplenishmentSiteSkus } from './Replenishment.data'

export const ReplenishmentView = () => {
  const { state } = useSettingsContext()
  const { projectId, scenarioId } = state
  const { data: replenishmentSiteSkus, isLoading } = useReplenishmentSiteSkus({
    projectId,
    scenarioId,
  })

  return (
    <SettingsPage title="Replenishment">
      <ReplenishmentTable
        data={replenishmentSiteSkus ?? []}
        isLoading={isLoading}
      />
    </SettingsPage>
  )
}
